<style lang="less">
.app-menu {
  .h-menu {
    font-size: 14px;
    .h-menu-li-selected {
      .h-menu-show:after {
        width: 4px;
      }
    }
    > li > .h-menu-show {
      font-size: 15px;
      overflow: visible;
      .h-menu-show-icon {
        font-size: 20px;
      }
      .h-menu-show-desc {
        transition: opacity 0.1s cubic-bezier(0.645, 0.045, 0.355, 1), width 0.1s cubic-bezier(0.645, 0.045, 0.355, 1);
      }
      // 折叠态角标不被侧栏裁切
      .h-badge,
      .h-menu-count,
      .h-tag {
        z-index: 2;
      }
    }
  }
  .h-menu.h-menu-size-collapse > .h-menu-li > .h-menu-show {
    padding-left: 24px;
    overflow: visible;
    .h-menu-show-icon {
      font-size: 20px;
    }
  }
  .h-menu.h-menu-white {
    color: rgb(49, 58, 70);
  }
}
</style>
<template>
  <div class="app-menu">
    <appLogo></appLogo>
    <Menu :datas="menus" :mode="menuMode" accordion @select="trigger" ref="menu" :className="`h-menu-${theme}`"></Menu>
    <div class="app-menu-mask" @click="hideMenu"></div>
  </div>
</template>
<script>
import { mapState } from 'vuex';
import appLogo from './app-logo';

export default {
  props: {
    theme: String
  },
  data() {
    return {};
  },
  watch: {
    $route() {
      this.$nextTick(() => this.menuSelect());
    },
    menuKeys(newKeys, oldKeys) {
      if (this.menuKeysEqual(newKeys, oldKeys)) {
        return;
      }
      this.$nextTick(() => this.menuSelect());
    }
  },
  mounted() {
    this.init();
  },
  computed: {
    ...mapState(['siderCollapsed', 'menus', 'menuKeys']),
    menuMode() {
      return this.siderCollapsed ? 'collapse' : 'vertical';
    }
  },
  methods: {
    menuKeysEqual(left, right) {
      if (!Array.isArray(left) || !Array.isArray(right) || left.length !== right.length) {
        return false;
      }
      for (let i = 0; i < left.length; i++) {
        if (left[i] !== right[i]) {
          return false;
        }
      }
      return true;
    },
    init() {
      this.menuSelect();
    },
    menuSelect() {
      if (this.$route.name) {
        const key = this.$route.meta && this.$route.meta.menuKey ? this.$route.meta.menuKey : this.$route.name;
        this.$refs.menu.select(key);
      }
    },
    trigger(data) {
      const item = data && typeof data === 'object' ? data : { key: data };
      if (item.children?.length) return;
      if (!item.key || this.$route.name === item.key) return;
      this.$router.push({ name: item.key });
    },
    hideMenu() {
      this.$store.commit('updateSiderCollapse', true);
    }
  },
  components: {
    appLogo
  }
};
</script>
